var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#E4E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#E4E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2571 7.77791C5.75287 7.21437 5.50076 6.93259 5.49125 6.69312C5.48299 6.48509 5.57238 6.28515 5.73292 6.15259C5.91773 6 6.29583 6 7.05202 6H16.9473C17.7035 6 18.0816 6 18.2664 6.15259C18.427 6.28515 18.5163 6.48509 18.5081 6.69312C18.4986 6.93259 18.2465 7.21437 17.7422 7.77791L13.9381 12.0296C13.8376 12.142 13.7873 12.1981 13.7515 12.2621C13.7197 12.3187 13.6964 12.3798 13.6823 12.4432C13.6663 12.5148 13.6663 12.5901 13.6663 12.7409V16.3056C13.6663 16.436 13.6663 16.5011 13.6453 16.5575C13.6267 16.6073 13.5965 16.6519 13.5572 16.6877C13.5127 16.7281 13.4521 16.7524 13.3311 16.8008L11.0644 17.7074C10.8194 17.8054 10.6969 17.8545 10.5985 17.834C10.5125 17.8161 10.437 17.765 10.3885 17.6918C10.333 17.6081 10.333 17.4762 10.333 17.2122V12.7409C10.333 12.5901 10.333 12.5148 10.3171 12.4432C10.303 12.3798 10.2796 12.3187 10.2479 12.2621C10.212 12.1981 10.1618 12.142 10.0613 12.0296L6.2571 7.77791Z",
    stroke: "#545454",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/filter-1.17837659afdae4fa91d1d4dc3d65ade1.svg";
export { ForwardRef as ReactComponent };